import { MicrosoftXboxControllerIcon } from './MicrosoftXboxControllerIcon';

/**
 * author: Austin Andrews
 * id 74BB58AC-EF8B-447C-A15D-C444F1F67D93
 * name microsoft-xbox-controller
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller.svg
 * tags
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadIcon = MicrosoftXboxControllerIcon;
export default MicrosoftXboxGamepadIcon